/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface DashboardCctScreeningSearch
 */
export interface DashboardCctScreeningSearch {
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardCctScreeningSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof DashboardCctScreeningSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardCctScreeningSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardCctScreeningSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof DashboardCctScreeningSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardCctScreeningSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the DashboardCctScreeningSearch interface.
 */
export function instanceOfDashboardCctScreeningSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardCctScreeningSearchFromJSON(json: any): DashboardCctScreeningSearch {
    return DashboardCctScreeningSearchFromJSONTyped(json, false);
}

export function DashboardCctScreeningSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardCctScreeningSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function DashboardCctScreeningSearchToJSON(value?: DashboardCctScreeningSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

